
import { mdiDotsHorizontal, mdiMenuDown } from "@mdi/js";
import VueResponsiveMenu from "vue-responsive-menu";
import { mapGetters } from "vuex";

export default {
  components: { VueResponsiveMenu },

  data() {
    return {
      mdiMenuDown,
      mdiDotsHorizontal,

      catalogItemTitle: "",
    };
  },

  computed: {
    ...mapGetters({
      headerNav: "v2/nav/getHeaderNav",
      genderNav: "v2/nav/getHeaderGenderNav",
      defaultFilters: "profiles/getDefaultFilters",
      currentGender: "global/getCurrentGender",
    }),
    adaptiveMenu() {
      return this.headerNav.slice();
    },
    catalogItemTitles() {
      return {
        female: this.$t("female"),
        male: this.$t("male"),
        transgender: this.$t("shemale"),
      };
    },
    isCatalog() {
      return this.$route.name.includes("catalog");
    },
  },

  watch: {
    $route: {
      handler(newRoute) {
        if (newRoute.name?.includes("catalog")) {
          this.catalogMenuItemTitle();
        } else {
          this.catalogItemTitle =
            this.catalogItemTitles[this.currentGender] || this.$t("female");
        }
      },
      deep: true,
      immediate: true,
    },
    currentGender: {
      handler() {
        this.catalogMenuItemTitle();
      },
    },
  },

  methods: {
    catalogMenuItemTitle() {
      const gender = this.defaultFilters.gender || this.currentGender;
      this.catalogItemTitle = gender
        ? this.catalogItemTitles[gender]
        : this.$t("all");
    },
  },
};
